import React, { FC, useCallback, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import { FlexRow } from 'components/Flex'
import { TextButton } from 'components/Button'
import { Spacer } from 'components/Utility'
import { StoreDeliveryFeeConfirmCard } from 'components/Card'
import { BreadType } from 'types/bread'
import { StockType } from 'types/stock'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { getBreadShortName } from 'lib/helper'

type Props = {
  breadList: BreadType[]
  stocks: StockType[]
  storeDeliveryBreads: StoreDeliveryBreadType[]
}

const StoreDeliveryFeeConfirmCardList: FC<Props> = (props) => {
  const { breadList, stocks, storeDeliveryBreads } = props

  const [expandStatus, setIsExpandedAll] = useState<string>('expanded')

  const expandAllAccordion = useCallback(() => setIsExpandedAll('expanded'), [setIsExpandedAll])
  const foldAllAccordion = useCallback(() => setIsExpandedAll('folded'), [setIsExpandedAll])
  const resetExpandedStatus = useCallback(() => setIsExpandedAll(''), [setIsExpandedAll])

  return (
    <>
      <p className={text.font_bold}>{breadList.length}件の商品を表示中</p>
      <Spacer size={12} />
      <FlexRow justifyContent={'start'}>
        <TextButton
          disabled={expandStatus === 'expanded'}
          iconPath={expandStatus === 'expanded' ? '/icon/grey/plus.svg' : '/icon/blue/plus.svg'}
          label={'すべて開く'}
          onClick={expandAllAccordion}
        />
        <Spacer size={32} axis={'horizontal'} />
        <TextButton
          disabled={expandStatus === 'folded'}
          iconPath={expandStatus === 'folded' ? '/icon/grey/minus.svg' : '/icon/blue/minus.svg'}
          label={'すべてたたむ'}
          onClick={foldAllAccordion}
        />
      </FlexRow>
      <Spacer size={12} />
      {breadList.map((bread, index) => {
        if (!bread.bread_ref) return
        const storeDeliveryBread = storeDeliveryBreads.find((_) => _.bread_ref?.id === bread.bread_ref?.id)
        if (!storeDeliveryBread) return
        const packageSize = storeDeliveryBread.package_size
        const deletedStocks = stocks.filter((stock) => stock.bread_ref.id === bread.bread_ref?.id)
        return (
          <React.Fragment key={bread.bread_ref.id}>
            {index !== 0 && <Spacer size={8} />}
            <StoreDeliveryFeeConfirmCard
              breadName={getBreadShortName(bread)}
              expandStatus={expandStatus}
              imageUrl={bread.image_urls[0] || ''}
              packageSize={packageSize}
              resetExpandedStatus={resetExpandedStatus}
              stocks={deletedStocks}
            />
          </React.Fragment>
        )
      })}
    </>
  )
}

export default StoreDeliveryFeeConfirmCardList
